import "react";
import { styled as e } from "styled-components";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-checkbox";
//#region src/components/Table/SelectionCheckbox.tsx
var r = e(n.Root)`
    width: 18px;
    height: 18px;
    border-radius: ${({ theme: e }) => e.radii.sm};
    border: 2px solid ${({ theme: e }) => e.colors.input};
    background-color: ${({ theme: e }) => e.colors.card};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};
    outline: none;

    &[data-state='checked'],
    &[data-state='indeterminate'] {
        background-color: ${({ theme: e }) => e.colors.primary};
        border-color: ${({ theme: e }) => e.colors.primary};
    }

    &:focus-visible {
        outline: 2px solid ${({ theme: e }) => e.colors.ring};
        outline-offset: 2px;
    }

    &[data-disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }
`, i = e(n.Indicator)`
    color: ${({ theme: e }) => e.colors.primaryForeground};
    display: flex;
    align-items: center;
    justify-content: center;
`, a = ({ isIndeterminate: e }) => /* @__PURE__ */ t("svg", {
	width: "10",
	height: "10",
	viewBox: "0 0 10 10",
	fill: "none",
	children: e ? /* @__PURE__ */ t("path", {
		d: "M2 5h6",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ t("path", {
		d: "M1.5 5l2.5 2.5 4.5-5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), o = ({ checked: e, onCheckedChange: n, disabled: o }) => /* @__PURE__ */ t(r, {
	checked: e,
	onCheckedChange: n,
	disabled: o,
	children: /* @__PURE__ */ t(i, { children: /* @__PURE__ */ t(a, { isIndeterminate: e === "indeterminate" }) })
});
//#endregion
export { o as SelectionCheckbox };
